import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { PublicLayout } from "@/components/PublicLayout";

export default function Unsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState({ status: "working", msg: "Unsubscribing…" });
  useEffect(() => {
    api.post(`/email/unsubscribe/${token}`)
      .then((r) => setState({ status: "done", msg: r.data.message }))
      .catch((e) => setState({ status: "error", msg: errMsg(e) }));
  }, [token]);
  return (
    <PublicLayout>
      <section className="mx-auto max-w-xl px-5 py-24 text-center sm:px-8">
        <p className="eyebrow">Email preferences</p>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl">{state.status === "error" ? "Link not found" : "Unsubscribe"}</h1>
        <p data-testid="unsubscribe-message" data-status={state.status} className="mt-5 text-muted-foreground">{state.msg}</p>
      </section>
    </PublicLayout>
  );
}
